import { render, staticRenderFns } from "./ApprovalSubmitterComponent.vue?vue&type=template&id=62bca88e&"
import script from "./ApprovalSubmitterComponent.vue?vue&type=script&lang=js&"
export * from "./ApprovalSubmitterComponent.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalSubmitterComponent.vue?vue&type=style&index=0&id=62bca88e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports